export const toAvailableVariables = (variables = [], source) =>
  variables.map(({ variable_name, example_usage }) => ({
    name: variable_name,
    token: example_usage || `{{${variable_name}}}`,
    source,
  }));

// Delivery channel options. Currently only "Email" is available.
export const NOTIFICATION_TYPES = { EMAIL: "email" };

// Never is UI-only (DELETE); the other values are API timing options.
export const TIMING_OPTIONS = {
  NEVER: "never",
  TRIGGERED: "send_on_triggered",
  UNTRIGGERED: "send_on_untriggered",
  BOTH: "send_on_both",
};
